// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"046ee206","263":"79c5dcdb","453":"213f82dd","572":"cd5b4e80","818":"41a40737","862":"8e3129a7"}[chunkId] + ".chunk.js";
};